import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';

import { ProductCategory, useGetProductsByIdQuery } from '@client/api';

import { PageContentAnimation } from '../../../../components/layout';
import { ProductInformationCard } from '../components/product-information-card.component';
import { SubProductsCard } from '../components/sub-products/sub-products-card.component';

export function ProductDetailsTab() {
  const { id } = useParams<{ id: string }>();

  const { data: product, isFetching } = useGetProductsByIdQuery(
    { id: id ?? '' },
    { skip: id == null },
  );

  // Track the live category (changes during editing before save)
  const [liveCategory, setLiveCategory] = useState<ProductCategory | undefined>(undefined);

  const handleCategoryChange = useCallback((category: ProductCategory | undefined) => {
    setLiveCategory(category);
  }, []);

  // Use live category while editing, otherwise fall back to saved product category
  const effectiveCategory = liveCategory ?? product?.category;

  return (
    <PageContentAnimation>
      <div className="space-y-2">
        <ProductInformationCard
          product={product}
          isFetching={isFetching}
          onCategoryChange={handleCategoryChange}
        />
        <SubProductsCard product={product} dimmed={effectiveCategory !== 'Felleskostnader'} />
      </div>
    </PageContentAnimation>
  );
}
